import {
    course_class_getAttendanceById_Api,
    course_class_getGradeById_Api,
    course_getCourseClassById_Api,
    course_getStudentById_Api,
    course_getSubjectById_Api,
    course_getTeacherById_Api,
} from 'apis'
import {withProps} from 'recompose'
import {FetchEntityById} from 'views/Shared/components/FetchEntityById'
import {
    course_class_exam_attempt_getById_Api,
    course_class_exam_getById_Api,
    course_getCourseById_Api,
    member_getById_Api
} from '../../../../apis'

export const FetchMemberById = withProps({
    apiInfo: member_getById_Api,
})(FetchEntityById)

export const FetchSubjectById = withProps({
    apiInfo: course_getSubjectById_Api,
})(FetchEntityById)

export const FetchStudentById = withProps({
    apiInfo: course_getStudentById_Api,
})(FetchEntityById)

export const FetchCourseById = withProps({
    apiInfo: course_getCourseById_Api,
})(FetchEntityById)

export const FetchGradeById = withProps({
    apiInfo: course_class_getGradeById_Api,
})(FetchEntityById)

export const FetchAttendanceById = withProps({
    apiInfo: course_class_getAttendanceById_Api,
})(FetchEntityById)

export const FetchTeacherById = withProps({
    apiInfo: course_getTeacherById_Api,
})(FetchEntityById)

export const FetchClassById = withProps({
    apiInfo: course_getCourseClassById_Api,
})(FetchEntityById)

export const FetchCourseClassExamById = withProps({
    apiInfo: course_class_exam_getById_Api,
})(FetchEntityById)

export const FetchCourseClassExamAttemptById = withProps({
    apiInfo: course_class_exam_attempt_getById_Api,
})(FetchEntityById)

